import { TAPIError } from '../model/types/apiError.type';
import { FieldErrors } from '../../../entities/modal/model/types/modalFieldErrors';

export const getUpdatedFieldErrors = (fieldErrors: FieldErrors, apiErrors: TAPIError[]) => {
    const updatedFieldErrors: FieldErrors = { ...fieldErrors };

    apiErrors.forEach((err) => {
        if (err.source.pointer === 'estimateId' || err.source.pointer === 'projectId') {
            updatedFieldErrors.objectOrEstimate = {
                isError: true,
                errorMessage: err.title,
            };
        }
        if (err.source.pointer === 'executorId') {
            updatedFieldErrors.executor = {
                isError: true,
                errorMessage: err.title,
            };
        }
        if (err.source.pointer === 'tags') {
            updatedFieldErrors.tags = {
                isError: true,
                errorMessage: err.title,
            };
        }
        if (err.source.pointer === 'dateString') {
            updatedFieldErrors.date = {
                isError: true,
                errorMessage: err.title,
            };
        }
    });
    return updatedFieldErrors;
};
